import React from 'react'
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import VODCard from './vodCard';
import update from 'immutability-helper';
import { SERVER_IP, httpOption } from '../../../../Util/Config';

const propTypes = {
  onClickVOD: PropTypes.func,
  vod: PropTypes.arrayOf(PropTypes.object).isRequired,
  cast: PropTypes.string.isRequired,
  cate: PropTypes.string.isRequired,
  // loadMore: PropTypes.func,
}

const defaultProps = {
  onClickVOD: null,
  vod: null,
  cast: null,
  cate: null,
}

class VODInfiniteList extends React.Component<propTypes> {
  constructor(props) {
    super(props)

    const hasMoreFalse = this.props.vod.length < 60 ? false : true

    this.state = {
      hasMore: hasMoreFalse,
      page: 1,
      mList: this.props.vod
    }
  }

  loadMoreList = () => {
    this.setState(update(this.state, { page: { $set: this.state.page + 1 } }),
      async () => (
        await window.$.ajax({
          url: `${SERVER_IP}/cli/vod/${this.props.cast}?cate=${this.props.cate}&page=${this.state.page}`,
          type: 'get',
          ...httpOption,
        })
          .then((res) => {
            if (res.list.length < 30) {
              this.setState({ hasMore: false })
            }
            this.setState(update(this.state, {
              mList: { $push: res.list }
            }))
          })
          .catch(() => window.$.ajax(this))
      ))
  }

  render() {
    const { onClickVOD } = this.props

    return (
      <InfiniteScroll
        scrollableTarget="scroll-container"
        dataLength={this.state.mList.length}
        next={this.loadMoreList}
        hasMore={this.state.hasMore}
        loader={
          <div className="loader-container">
            <h4 className="loader">Loading...</h4>
          </div>
        }
      >
        <ul className="sub-ul">
          {
            this.state.mList.map((content, i) => {
              return (
                <VODCard key={i} type="infinity" content={content} onClickVOD={onClickVOD} />
              )
            })
          }
        </ul>
      </InfiniteScroll>
    )
  }
}

VODInfiniteList.propTypes = propTypes
VODInfiniteList.defaultProps = defaultProps

export default VODInfiniteList
